import React, { useEffect } from "react";
import TopNav from "../TopNav";

export default function PrivacyPolicy() {
  // scroll to the top
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, []);

  return (
    <div>
      <TopNav />
      <div className="pageContainer max-width-700">
        <h3>Privacy Policy </h3>
        <p>Effective Date: December, 2024.</p>

        <p>
          Block Forever App ("we," "our," or "us") is committed to protecting
          your privacy.
        </p>

        <p>
          This Privacy Policy explains how we handle your data when you use our
          adult content blocking app.{" "}
        </p>

        <h4> What Data We Collect </h4>

        <p>
          We do not collect or store your browsing data. All data related to
          blocking adult content is stored locally on your computer and is not
          transmitted to our servers. If you choose to make a purchase, we
          collect and store the following information: Your name, email address,
          and purchase details. Payment information is processed securely by
          Stripe, our third-party payment provider.
        </p>

        <h4> How Your Data Is Used </h4>
        <p>
          Blocking Features: Data related to blocking adult content is stored
          locally on your device to ensure the app functions correctly.
        </p>
        <p>
          Purchases: Information collected during a purchase is used to manage
          your subscription or one-time purchase and to communicate with you
          about your account. We use Stripe to handle payments securely.
        </p>

        <h4> Your Data, Your Control </h4>
        <p>
          Since blocking data is stored locally on your device, you have full
          control over it.{" "}
        </p>
        <h4> Security</h4>
        <p>
          We take reasonable steps to protect the information you provide during
          purchases. However, no method of transmission over the internet is
          100% secure, and we cannot guarantee absolute security.
        </p>
        <h4> Changes to This Privacy Policy</h4>
        <p>
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page, and we encourage you to review it
          periodically.
        </p>

        <h4> Contact Us</h4>

        <p>
          If you have any questions about this Privacy Policy, please contact us
          at blockforeverapp@gmail.com{" "}
        </p>
      </div>
    </div>
  );
}
